import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import toastr from "toastr";
import { initialEmailTemplateForm } from "../_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import { Validation } from "app/_helpers/validation/Validation";
import {
  updateEmailTemplate,
  getEmailTemplateById,
} from "app/_services/ehs/ehsCapaServices";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { UserWorkFlowRoleList, escalationEventLabel } from "app/_constants/constant";
import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import RichTextarea from "app/Components/RichTextarea/RichTextarea";
const AddEditEmailTemplate = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [form, setForm] = useState({ ...initialEmailTemplateForm });
  const [errorForm, setErrorForm] = useState({});
  const [users, setUsers] = useState([]);
  const [usersCC, setUsersCC] = useState([]);
  const [dynamicVariables, setDynamicVariables] = useState("");

  const onChange = ({ target: { name, type, checked, value } }) =>
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));

  const onSubmit = async () => {
    const errObj = Validation(form, [
      {
        field_name: "event",
        label: "event",
        type: "string",
        isRequired: true,
      },
    ]);

    setErrorForm(errObj);

    for (const key in errObj) if (errObj[key]) return;

    const response = id ? await updateEmailTemplate(id, form) : {};

    if (!response?.status) return toastr.error(response?.message);

    toastr.success("Success");

    history.push("/admin-panel/manage-email-template");
  };

  useEffect(() => {
    getEmailTemplateById(id).then((response) => {
      if (!response?.data) return;
      setForm(response.data);

      if (response?.data?.dynamicVariables) {
        setDynamicVariables(
          Object.keys(response?.data?.dynamicVariables)
            ?.map((x) => x)
            .join(", ")
        );
      }
      setUsers(response.data?.escalateGroupTo?.split(","));
      setUsersCC(response.data?.escalateCC?.split(","));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          {
            name: "Manage Email Template",
            path: "/admin-panel/manage-email-template",
          },
          { name: "Update Email Template", path: "#" },
        ]}
      />
      <div className="card p-3 mt-4 overflow-inherit">
        <div className="simple-card-title title-overflowInherit">
          <h3 class="text-capitalize mb-0">Update Email Template</h3>
          <BackBtn />
        </div>
        <div className="ehsFormWrapper">
          <Row>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Event Type</h5>
                <input
                  name="event"
                  value={escalationEventLabel[form?.event]}
                  className="form-control"
                  readOnly
                />
                <span className="small text-danger">{errorForm?.event}</span>
              </div>
            </Col>

            {/* <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Email To</h5>

                <MultiSelectWithCheckbox
                  // disabled={form?.eventStatus=="inProgress"?true:false}
                  options={UserWorkFlowRoleList.map((user) => ({
                    label: `${user.name}`,
                    value: user.name,
                  }))}
                  value={UserWorkFlowRoleList.filter((user) =>
                    users?.includes(user.name)
                  ).map((user) => ({
                    label: `${user.name}`,
                    value: user.name,
                  }))}
                  onChange={(e) => {
                    setUsers(e.map((d) => d.value));
                    setForm((prev) => {
                      let obj = JSON.parse(JSON.stringify(prev));
                      obj.escalateGroupTo = e.map((d) => d.value).join();
                      return obj;
                    });
                  }}
                />
                <span className="small text-danger">{errorForm.escalateGroupTo}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Email CC</h5>
                <MultiSelectWithCheckbox
                  // disabled={form?.eventStatus=="inProgress"?true:false}
                  options={UserWorkFlowRoleList.map((user) => ({
                    label: `${user.name}`,
                    value: user.name,
                  }))}
                  value={UserWorkFlowRoleList?.filter((user) =>
                    usersCC?.includes(user.name)
                  ).map((user) => ({
                    label: `${user.name}`,
                    value: user.name,
                  }))}
                  onChange={(e) => {
                    setUsersCC(e.map((d) => d.value));
                    setForm((prev) => {
                      let obj = JSON.parse(JSON.stringify(prev));
                      obj.escalateCC = e.map((d) => d.value).join();
                      return obj;
                    });
                  }}
                />
                <span className="small text-danger">{errorForm.escalateCC}</span>
              </div>
            </Col> */}
            {/* <Col lg={4}>
                            <div className="form-group viewbox">
                                <h5 className="w-500 mb-1">Notification Message To User</h5>
                                <input name="event" value={form.notificationMessageToUser} className="form-control" readOnly />
                                <span className="small text-danger">{errorForm.notificationMessageToUser}</span>
                            </div>
                        </Col> */}
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Subject</h5>
                <input
                  value={form.subject}
                  name="subject"
                  onChange={onChange}
                  class="form-control"
                  placeholder="Max 1000 Characters"
                  maxLength={1000}
                />
                <span className="small text-danger">{errorForm?.subject}</span>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Notification Message</h5>
                <textarea
                  value={form.notificationMessage}
                  name="notificationMessage"
                  onChange={onChange}
                  class="form-control"
                  style={{ height: "150px" }}
                  placeholder="Max 1000 Characters"
                  maxLength={1000}
                />
                <span className="small text-danger">
                  {errorForm?.notificationMessage}
                </span>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Email Template</h5>
                {/* <RichTextarea
                  name={"emailTemplate"}
                  onChange={onChange}
                  value={form?.emailTemplate}
                /> */}
                <textarea
                  value={form.emailTemplate}
                  name="emailTemplate"
                  onChange={onChange}
                  class="form-control"
                  style={{ height: "150px" }}
                  placeholder="Max 1000 Characters"
                  maxLength={2000}
                />
                <span className="small text-danger">{errorForm?.emailTemplate}</span>
              </div>
              <span>*{dynamicVariables}</span>
            </Col>
          </Row>
          <div className="mb-2 mt-3 text-center">
            <Button
              onClick={onSubmit}
              type="submit"
              variant="primary"
              className="m-1 text-capitalize"
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditEmailTemplate;
